import { createSlice } from '@reduxjs/toolkit';

import { ReduxState } from '../../AppLoader/types';
import ContentEditStateDefinition from './ContentEditStateDefinition';

const contentEditSlice = createSlice({
  name: 'contentEdit',
  initialState: ContentEditStateDefinition.getInitialState(),
  reducers: {},
});

export default contentEditSlice.reducer;

/**
 * True while the user has a content edit task in flight. Seeded server-side from the
 * ai_tasks table; used to disable the AI Edit button so a second task can't be started.
 */
export const selectIsPolling = (state: ReduxState) =>
  state.contentEdit.isPolling;

export const selectAIEditButtonVisible = (state: ReduxState): boolean => {
  return state.auth?.permissions?.aiFeaturesVisible ?? false;
};
